import { render, staticRenderFns } from "./homeIndex.vue?vue&type=template&id=0c870f88&scoped=true&"
import script from "./homeIndex.vue?vue&type=script&lang=js&"
export * from "./homeIndex.vue?vue&type=script&lang=js&"
import style0 from "./homeIndex.vue?vue&type=style&index=0&id=0c870f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c870f88",
  null
  
)

export default component.exports